<template>
  <div class="search-container">
    <!-- Search Input -->
    <div class="search-box">
      <input
        type="text"
        v-model="query"
        @input="handleInput"
        placeholder="Namn på sektion eller förening..."
        class="search-input"
      />
      <i slot="append" class="fas fa-search"></i>
    </div>

    <!-- Loader -->
    <div v-if="loading" class="d-flex justify-content-center mb-8 mt-8">
      <memlist-spinner />
    </div>

    <!-- Search Results -->
    <ul v-if="results.length && !loading" class="search-results">
      <li v-for="(result, index) in results" :key="index" 
          @click="result.isActive ? null : selectResult(result)" 
          :class="{'active-result': !result.isActive, 'inactive-result': result.isActive}">
        
        <!-- Show Membership Info on Separate Box for Active Membership -->
        <div v-if="result.isActive" class="active-box">
          <span><b>{{ result.name }}</b></span>
          <div>
            <i class="fa fa-check"></i> Aktivt medlemskap {{ result.vfdt }} - {{ result.vtdt }}
          </div>
        </div>
        
        <!-- Show Name in Regular Box if not Active -->
        <div v-else class="regular-box">
          <span><b>{{ result.name }}</b></span>
        </div>
      </li>
    </ul>

    <!-- Selected Entry -->
    <div v-if="selectedEntry" class="selected-entry">
      <strong>Vald:</strong> {{ selectedEntry.name }}
    </div>
  </div>
</template>



<script>
export default {
  name: 'SearchCompanyInput',
  props: ['companies','memberships'],
  data() {
    return {
      query: '',
      results: [],
      loading: false,
      selectedEntry: null,
      debounceTimer: null
    };
  },
  mounted() {
    this.search();
  },
  methods: {
    handleInput() {
      if (this.query.trim() === '') {
        this.results = [];
        this.selectedEntry = null;
        return;
      }

      // Clear previous debounce timer
      clearTimeout(this.debounceTimer);

      // Set a slight delay before searching (prevents spam requests)
      this.debounceTimer = setTimeout(() => {
        this.search();
      }, 500); // 500ms delay
    },
    async search() {
      this.loading = true;
      this.results = [];

      const today = new Date().toISOString().split('T')[0]; // Get today's date in YYYY-MM-DD format

      const searchlist = this.companies.map(i => {
        // Safe check for memberships being null/undefined
        const membership = this.memberships ? this.memberships.find(m => m.company_id === i.company_id) : null;

        const isActive = membership && membership.vfdt <= today && membership.vtdt >= today;

        return {
          name: i.name,
          company_id: i.company_id,
          frontend: i.frontend ? i.frontend : { display: true },
          isActive,
          vfdt: isActive ? membership.vfdt : '',
          vtdt: isActive ? membership.vtdt : ''
        };
      });

      this.results = searchlist.filter(i => i.frontend.display && i.name.toLowerCase().indexOf(this.query.toLowerCase()) >= 0);

      this.loading = false;
    },

    selectResult(result) {
      this.selectedEntry = result;
      this.results = []; // Hide results after selection

      this.$emit('selected', result.company_id);
    }
  }
};
</script>

<style scoped>

.search-container {}

.search-box {
  display: flex;
  align-items: center;
  border: 1px solid #ccc;
  padding: 8px;
  border-radius: 5px;
  background: #fff;
  position: relative;
}

.search-input {
  flex: 1;
  border: none;
  outline: none;
  font-size: 16px;
  padding: 8px 40px 8px 10px; /* Prevents overlap with the icon */
  width: 100%;
}


/* Search Results */
.search-results {
  margin-top: 10px;
  padding: 0;
  list-style: none;
  border: 1px solid #ccc;
  border-radius: 5px;
  background: #fff;
}

.search-results li {
  padding: 15px;
  cursor: pointer;
  transition: background 0.2s;
  border-bottom: 1px solid #f0f0f0;
}

.search-results li:last-child {
  border-bottom: none; /* Remove border from last item */
}

/* Highlight on Hover for Clickable Items */
.regular-box:hover {
  background: #f0f0f0;
}

/* Active Result Box */
.active-result {
  cursor: pointer; /* Clickable */
}

.inactive-result {
  cursor: not-allowed; /* Non-clickable */
}

/* Active Box for Active Membership */
.active-box {
  background-color: #d9face;
  padding: 4px;
  border: 1px solid #ccc;
  margin-bottom: 2px;
  border-radius: 5px;
}

.active-box i {
  margin-right: 8px;
}

/* Regular Box for Inactive Results */
.regular-box {
  background-color: #fff;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
}

/* Selected Entry */
.selected-entry {
  margin-top: 10px;
  padding: 10px;
  border: 1px solid #2D9BF0;
  font-size: 16px;
}

/* Mobile Fix */
@media (max-width: 480px) {
  .search-box {
    padding: 10px;
  }
  
  .search-input {
    padding-right: 35px; /* Adjust space for the icon */
  }
  
}
</style>

